import assert from "assert";
import moment from "moment-timezone";
import { Array, Dictionary, InstanceOf, Number, Record as RuntypeRecord, String, Union } from "runtypes";
export const TZ = String.check(process.env.TZ ?? "America/Chicago");
assert(!!moment.tz.zone(TZ), `Invalid time zone: ${TZ}`);
export const Semester = RuntypeRecord({
  year: Number,
  name: String,
  start: Union(InstanceOf(Date), String),
  end: Union(InstanceOf(Date), String),
  index: Number,
  courses: Array(String),
  primary: String,
  instructors: Dictionary(Array(String))
});
export const semesters = Array(Semester).check(
  [
    {
      year: 2018,
      name: "Fall",
      start: "2018-08-27",
      end: "2018-12-20",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2019,
      name: "Spring",
      start: "2019-01-14",
      end: "2019-05-10",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2019,
      name: "Fall",
      start: "2019-08-26",
      end: "2019-12-20",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2020,
      name: "Spring",
      start: "2020-01-21",
      end: "2020-05-15",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2020,
      name: "Fall",
      start: "2020-08-24",
      end: "2020-12-18",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2021,
      name: "Spring",
      start: "2021-01-25",
      end: "2021-05-21",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2021,
      name: "Summer",
      start: "2021-06-14",
      end: "2021-08-07",
      courses: ["CS/125"],
      primary: "125",
      instructors: {
        "CS/125": ["challen"]
      }
    },
    {
      year: 2021,
      name: "Fall",
      start: "2021-08-23",
      end: "2021-12-17",
      courses: ["CS/124", "CS/125"],
      primary: "124",
      instructors: {
        "CS/125": ["challen"],
        "CS/124": ["challen", "colleenl"]
      }
    },
    {
      year: 2022,
      name: "Spring",
      start: "2022-01-18",
      end: "2022-05-13",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2022,
      name: "Summer",
      start: "2022-06-13",
      end: "2022-08-06",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2022,
      name: "Fall",
      start: "2022-08-22",
      end: "2022-12-16",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2023,
      name: "Spring",
      start: "2023-01-17",
      end: "2023-05-12",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2023,
      name: "Summer",
      start: "2023-06-12",
      end: "2023-08-05",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2023,
      name: "Fall",
      start: "2023-08-21",
      end: "2023-12-15",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2024,
      name: "Spring",
      start: "2024-01-16",
      end: "2024-05-10",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2024,
      name: "Fall",
      start: "2024-08-26",
      end: "2024-12-19",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2025,
      name: "Spring",
      start: "2025-01-21",
      end: "2025-05-15",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2025,
      name: "Fall",
      start: "2025-08-25",
      end: "2025-12-19",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    },
    {
      year: 2026,
      name: "Spring",
      start: "2026-01-20",
      end: "2026-05-15",
      courses: ["CS/124"],
      primary: "124",
      instructors: {
        "CS/124": ["challen"]
      }
    }
  ].map(({ start, end, ...s }) => {
    const semester = s;
    semester.start = moment.tz(`${start} 00:00:00`, "YYYY-MM-DD HH:mm:ss", TZ).toDate();
    semester.end = moment.tz(`${end} 00:00:00`, "YYYY-MM-DD HH:mm:ss", TZ).add(1, "day").toDate();
    assert(semester.start.getFullYear() === s.year);
    assert(semester.end.getFullYear() === s.year);
    semester.index = parseInt(`${s.year}${moment(semester.start).month().toString().padStart(2, "0")}`);
    return Semester.check(semester);
  })
);
export const semesterFromYearAndName = (y, n) => semesters.find(({ year, name }) => y === year && n === name);
export function semesterForTime(time = /* @__PURE__ */ new Date()) {
  const now = moment(time);
  return semesters.find(({ start, end }) => moment(start).isBefore(now) && moment(end).isAfter(now));
}
export function previousSemesters() {
  const now = moment();
  return semesters.filter(({ end }) => moment(end).isBefore(now));
}
export function nextSemesters() {
  const now = moment();
  return semesters.filter(({ start }) => moment(start).isAfter(now));
}
export const isPreviousSemester = (s) => previousSemesters().find(({ index }) => index === s.index) !== void 0;
export const isNextSemester = (s) => nextSemesters().find(({ index }) => index === s.index) !== void 0;
export const orderSemesters = (s1, s2) => s1.index - s2.index;
export const isCurrentOrNextSemester = (semester) => moment(semester.end).isAfter(moment());
export const semesterToPrefix = (semester) => `${semester.year}/${semester.name}`;
export const semesterFromPrefix = (prefix) => {
  const components = prefix.split("/");
  return semesterFromComponents(components[0], components[1]);
};
export const semesterFromComponents = (y, name) => {
  const year = parseInt(y);
  assert(!isNaN(year));
  const semester = semesters.find(
    (semester2) => semester2.year === year && semester2.name.toLowerCase() === name.toLowerCase()
  );
  assert(semester);
  return semester;
};
export const semesterFromShorthand = (shorthand) => semesterFromComponents(shorthand.substring(shorthand.length - 4), shorthand.substring(0, shorthand.length - 4));
export const semesterToCS124Query = (semester) => {
  const { year, name } = semester;
  return { year, semester: name, department: "CS", number: "124" };
};
//# sourceMappingURL=semesters.js.map
